import { createTheme } from "@mui/material";
import { faIR } from "@mui/material/locale";

export const theme = createTheme(
  {
    direction: "rtl",
    typography: {
      fontFamily: [
        "iranyekan",
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "sans-serif",
        "Arial",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
    },
    palette: {
      primary: {
        light: "#273c75",
        main: "#273c75",
        dark: "#273c75",
        contrastText: "#fff",
      },
      secondary: {
        light: "#f73378",
        main: "#f50057",
        dark: "#ab003c",
        contrastText: "#000",
      },
      light: {
        light: "#f73378",
        main: "#97a1aa",
        dark: "#1769aa",
        contrastText: "#fff",
      },
      green: {
        // works
        main: "green",
        contrastText: "#fff",
      },
      companyBlue: {
        // doesn’t work - defaults to a gray button
        main: "#65CFE9",
        contrastText: "#fff",
      },
      companyRed: {
        // doesn’t work - gray button
        main: "#E44D69",
        contrastText: "#fff",
      },
    },
    components: {
      MUIDataTableBodyRow: {
        styleOverrides: {
          root: {
            borderBottom: "1px solid #e3e3e3",
          },
        },
      },
      MuiFormControl: {
        styleOverrides: {
          root: {
            width: "100%",
          },
        },
      },
      MUIDataTable: {
        styleOverrides: {
          responsiveBase: {
            // position: "initial !important",
            overflow: "hidden",
          },
          root: {
            boxShadow: "none !important",
            width: "100%",
          },
        },
      },
      MUIDataTableSearch: {
        styleOverrides: {
          searchIcon: {
            display: "none",
          },
          main: {
            justifyContent: "flex-end",
          },
          searchText: {
            flex: "unset",
          },
        },
      },
      MUIDataTablePagination: {
        styleOverrides: {
          navContainer: {
            width: "100%",
            display: "inline-block",
          },
        },
      },
      MUIDataTableToolbar: {
        styleOverrides: {
          root: {
            alignItems: "center",
          },
          actions: {
            display: "flex",
            justifyContent: "flex-end",
            flex: "unset",
          },
          titleText: {
            textAlign: "right",
            fontSize: "16px",
            color: "rgba(0, 0, 0, 0.54)",
          },
        },
      },
      MUIDataTableHeadCell: {
        styleOverrides: {
          toolButton: {
            padding: "0px !important",
            marginRight: "0px !important",
            justifyContent: "center !important",
          },
          data: {
            fontSize: "14px",
          },
          contentWrapper: {
            justifyContent: "center",
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          head: {
            backgroundColor: "#e3e3e3 !important",
            textAlign: "center",
          },
          root: {
            justifyContent: "center",
          },
        },
      },
      MuiToolbar: {
        styleOverrides: {
          root: {
            // alignItems: "baseline",
            // marginTop: "10px",
          },
        },
      },
      MUIDataTableBodyCell: {
        styleOverrides: {
          root: {
            textAlign: "center",
            fontSize: "12px",
          },
        },
      },
      MuiTablePagination: {
        styleOverrides: {
          root: {
            justifyContent: "center",
            display: "flex",
          },
          toolbar: {
            marginTop: "0px",
            alignItems: "center",
          },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paperAnchorBottom: {
            borderTopRightRadius: "25px",
            borderTopLeftRadius: "25px",
          },
        },
      },
      MuiTimeline: {
        styleOverrides: {
          root: {
            gap: "0px !important",
          },
        },
      },
    },
  },
  faIR
);
